import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, ReplaySubject, Subject } from 'rxjs';
import { IContentLanguage } from '@fi-shared/fi-content-language-shared/fi-content-language-shared';
import { IChecklistV2ForList } from '@fi-shared/checklist/checklist-v2';

@Injectable()
export class FiChecklistStoreService {
    constructor() {}

    private _onChecklistDataChange$ = new ReplaySubject<void>(1);

    triggerChecklistDataChange$() {
        this._onChecklistDataChange$.next();
    }

    onChecklistDataChange$(): Observable<void> {
        return this._onChecklistDataChange$.asObservable();
    }

    private _availableContentLanguages: IContentLanguage[] = [];
    set availableContentLanguages(contentLanguages: IContentLanguage[]) {
        this._availableContentLanguages = contentLanguages;
    }

    get availableContentLanguages(): IContentLanguage[] {
        return this._availableContentLanguages;
    }

    private _selectedLanguageId$ = new BehaviorSubject<number>(undefined);

    set selectedLanguageId(languageId: number) {
        this._selectedLanguageId$.next(languageId);
    }

    get selectedLanguageId(): number {
        return this._selectedLanguageId$.value;
    }

    get selectedLanguageIdChange$(): Observable<number> {
        return this._selectedLanguageId$.asObservable();
    }

    // for proper updating list after deleting responses etc
    private _checklistListDataChanged$ = new Subject<IChecklistV2ForList>();
    get checklistListDataChanged$(): Observable<IChecklistV2ForList> {
        return this._checklistListDataChanged$.asObservable();
    }
    triggerChecklistListDataChanged(data: IChecklistV2ForList) {
        this._checklistListDataChanged$.next(data);
    }
}
